/* V2.0 */
//房源、门店、订单
const saas_room_order_paths = {
  'SAAS.ROOM_LIST': "/api/web/roomInfo/queryList",
  'SAAS.ROOM_MOVE_LIST': '/api/web/roomInfo/queryCanRemoveList',
  'SAAS.ROOM_DETAIL': "/api/web/roomInfo/queryDetailById",
  'SAAS.STORE_LIST': "/api/web/storeInfo/queryList",
  'SAAS.ROOM_TYPE_LIST': "/api/web/roomtypeInfo/queryList",
  'SAAS.ORDERINFO_GETCARDTOTAL': "/api/web/order-info/getCardTotal",
  'SAAS.ORDERINFO_MAKEDOORCARD': "/api/web/order-info/makeDoorCard",
  'SAAS.ROOM_EDIT': '/api/web/roomInfo/saveOrUpdate',
  'SAAS.ROOM_EDIT_CHECK': '/api/web/roomInfo/review',
  'SAAS.ROOM_PLATEFORM': '/api/web/platformInfo/queryList',
  'SAAS.ROOM_CHANGE_STORE': '/api/web/roomInfo/changeStore',

  'SAAS.ORDER_QUERY_LIST': '/api/web/order-info/queryList',
  'SAAS.ORDER_QUERY_DETAIL': '/api/web/order-info/detail',
  'SAAS.ORDER_EDIT': '/api/web/order-info/saveOrUpdate',
  'SAAS.ORDER_REBOOK': '/api/web/order-info/reBook',
  'SAAS.ORDER_EDIT_CANCEL': '/api/web/order-info/cancel',
  'SAAS.ORDER_EDIT_CHECKOUT': '/api/web/order-info/checkOut',
  'SAAS.ORDER_EXTEND': '/api/web/order-info/renew',
  'SAAS.CHANGE_HOUSE': 'api/web/order-info/changeRoom',

  'ROOM.POST_DELETE_BY_IDS': '/api/web/roomInfo/deleteByIds',
  'ROOM.POST_CHANGE_CLEAN_STATUS': '/api/web/roomInfo/changeCleanStatus',
  'ORDER.POST_EARLY_CHECK_IN': '/api/web/order-info/earlyCheckIn',
  'ORDER.POST_HEALTH_CODE_UPLOAD': '/api/web/order-info/pandemicPic',
  'ORDER.GET_ORDER_QRCODE': '/api/web/order-info/getOrderQRCode',
  
  'ORDER.MANUAL_VERIFY': '/api/web/order-info/manualVerify',
}

// 经营者相关接口地址
const manager_management = {
  'MANAGER.GET_LIST': '/api/web/managerInfo/queryList',
  'MANAGER.GET_DETAIL': '/api/web/managerInfo/queryDetailById',
  'MANAGER.POST_REVIEW': '/api/web/managerInfo/review',
  'MANAGER.POST_SAVE_OR_UPDATE': '/api/web/managerInfo/saveOrUpdate',
  'MANAGER.BULLETIN_BOARD': '/api/web/home-page/operator/bulletinBoard',
  'MANAGER.CHECK_IN_OVERVIEW': '/api/web/home-page/operator/checkInOverview',
  'MANAGER.CURRENT_MONTH_REVENUE': '/api/web/home-page/operator/currentMonthRevenue',
  'MANAGER.ORDER_SOURCE_SPREAD': '/api/web/home-page/operator/orderSourceSpread',
  'MANAGER.TODAY_ROOM_SOLD': '/api/web/home-page/operator/todayRoomSold',
}

// 用户相关
const user_management = {
  'USER.POST_LOGOUT': '/api/web/user/logout',
  'USER.POST_DELETE': '/api/web/user/delete',
  'USER.POST_CHANGE_PWD': '/api/web/user/changePwd',
  'USER.GET_LOGIN_CODE': '/api/web/user/captcha',
  'USER.POST_USER_LIST': '/api/web/user/findAllPaged',
  'USER.POST_UPDATE_STATUS': '/api/web/user/updateStatus',
  'USER.POST_SAVE_OR_UPDATE': '/api/web/user/saveOrUpdate',
  'USER.POST_PERMS_AND_MENU': '/api/web/permission/getCurrentUserPermission',
  'USER.POST_USER_INFO_BY_ID': '/api/web/user/getById',
  'USER.POST_FORGOT_PASSWORD': '/api/web/user/forgetPwd',
  'USER.POST_PHONE_CHECK_CODE': '/api/web/user/sendSms',
  'USER.POST_LOGIN_BY_PASSWORD': '/api/web/user/login',
  'USER.KEEPER_SAVE_OR_UPDATE': '/api/web/user/saveHousekeeper',
  'USER.KEEPER_DELETE': '/api/web/user/deleteHousekeeper',
}

// 设备相关
const device_management = {
  'DEVICE.GET_LIST': '/api/web/deviceInfo/findPage',
  'DEVICE.GET_BIND': '/api/web/deviceInfo/deviceBind',
  'DEVICE.GET_EXPORT': '/api/web/deviceInfo/export',
  'DEVICE.GET_UNBIND': '/api/web/deviceInfo/deviceUnbound',
  'DEVICE.GET_CAPTURE_LIST': '/api/web/captureRecord/findPage',
  'DEVICE.GET_NO_BIND_ROOM': '/api/web/roomInfo/getNoBindList',
  'DEVICE.GET_LOCK_LOG_LIST': '/api/web/unlockRecord/findPage',
  'DEVICE.GET_LOCK_LOG_LIST': '/api/web/unlockRecord/findPage',
  'DEVICE.GET_AUTH_LIST': '/api/web/authDeviceInfo/findPage',
  'DEVICE.POST_ADD_OR_UPDATE_AUTH': '/api/web/authDeviceInfo/saveOrUpdate',
  'DEVICE.POST_UPLOAD_AUTH_EXCEL': '/api/web/authDeviceInfo/importFile',
  'DEVICE.BATCH_UPGRADE': '/api/web/deviceInfo/versionUpgrade',
  'DEVICE.DOORBELL_CONFIG_ISSUED': '/api/web/deviceInfo/doorbellConfigIssued',
}

// 预警
const alarm = {
  'ALARM.GET_LIST': '/api/web/alarmInfo/findPage'
}

// 资源相关
const resource_management = {
  'DICT.DICT_DATA_LIST': '/api/web/dictInfo/getByTypes',
  'RESOURCE.GET_MULTI_LIST': '/api/web/dictInfo/getByTypes',
  'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE': '/api/web/areaInfo/getByParentCode',
  'RESOURCE.FIND_POLICE_STATION_LIST_BY_AREA_CODE': '/api/web/policeStation/findList',
  'RESOURCE.QUERY_POLICE_LIST':'/api/web/policeStation/findPage',
  'RESOURCE.FILE_UPLOAD':'/api/web/fileStorage/upload',
  'RESOURCE.QUERY_DICTS_LIST': '/api/web/dictInfo/getByTypes',
  'RESOURCE.QUERY_AREACODE_BY_NAME': '/api/web/areaInfo/getAllCodeByName',
}

// 角色与权限相关
const role_management = {
  'ROLE.POST_ALL': '/api/web/role/findAll',
  'ROLE.POST_LIST': '/api/web/role/findAllPaged',
  'ROLE.POST_DELETE': '/api/web/role/batchDelete',
  'ROLE.POST_ADD_OR_UPDATE': '/api/web/role/saveOrUpdate',
  'ROLE.POST_ALL_PERMISSION': '/api/web/permission/findAll',
}

// 门店管理
const shop_management = {
  'SHOP.GET_LIST': '/api/web/storeInfo/queryList',
  'SHOP.GET_DETAIL': '/api/web/storeInfo/queryDetailById',
  'SHOP.POST_SAVE': '/api/web/storeInfo/saveOrUpdate',
  'SHOP.DELETE': '/api/web/storeInfo/deleteByIds',
  'SHOP.KEEPER_LIST': '/api/web/storeInfo/housekeeperList',
  'SHOP.KEEPER_BOUND': '/api/web/storeInfo/housekeeperBound',
  'SHOP.KEEPER_UNBOUND': '/api/web/storeInfo/housekeeperUnbound'
}

// OTA
const OTA = {
  'OTA.GET_LIST': '/api/web/platformInfo/queryList',
  'OTA.POST_DELETE_BY_IDS': '/api/web/platformInfo/deleteByIds',
  'OTA.POST_ADD_OR_UPDATE': '/api/web/platformInfo/saveOrUpdate',
}

// 租客
const tenant = {
  'TENANT.STATISTICS': '/api/web/tenant-info/statistics',
  'TENANT.LIST': '/api/web/tenant-info/queryList',
  'TENANT.CHECK_IN_RECORD': '/api/web/tenant-info/checkInRecord',
  // 客户标签管理
  'TENANT.ADD_LABEL': '/api/web/customer-label/saveLabelRelation', // 新增标签关联
  'TENANT.DELETE_LABEL': '/api/web/customer-label/deleteLabelRelationByIds', // 批量删除标签关联

  // 标签管理
  'LABEL.LIST': '/api/web/customer-label/findPage', // 查询标签列表
  'LABEL.DETAIL': '/api/web/customer-label/getLabelDetail', // 标签详情查询
  'LABEL.ADD': '/api/web/customer-label/saveOrUpdateLabel', // 新增标签
  'LABEL.DELETE': '/api/web/customer-label/deleteLabelByIds', // 批量删除标签
}

// 访客
const visitor = {
  'VISITOR.DELETE': '/api/web/visitor-registration/deleteByIds',
  'VISITOR.DETAIL': '/api/web/visitor-registration/detail',
  'VISITOR.LIST': '/api/web/visitor-registration/findList',
  'VISITOR.PAGE': '/api/web/visitor-registration/findPage',
  'VISITOR.INTERVIEWEES': '/api/web/visitor-registration/getInterviewees',
  'VISITOR.SAVE': '/api/web/visitor-registration/saveOrUpdate',
  'VISITOR.UPLOAD': '/api/web/visitor-registration/uploadVisitorPhoto',
}

// 保洁
const clean = {
  'CLEAN.CLEANER.GET_LIST': '/api/web/staffInfo/queryList',
  'CLEAN.CLEANER.POST_SAVE': '/api/web/staffInfo/saveOrUpdate',
  'CLEAN.CLEANER.DELETE': '/api/web/staffInfo/deleteByIds',
  'CLEAN.CLEANER.GET_DETAIL': '/api/web/staffInfo/queryDetailById',
  'CLEAN.TASK.GET_LIST': '/api/web/staffTaskInfo/queryList',
  'CLEAN.TASK.POST_SAVE': '/api/web/staffTaskInfo/saveOrUpdate',
  'CLEAN.TASK.DELETE': '/api/web/staffTaskInfo/deleteByIds',
  'CLEAN.TASK.GET_DETAIL': '/api/web/staffTaskInfo/queryDetailById',
}

// 房型管理
const room_type_management = {
  'ROOM.TYPE.GET_LIST': '/api/web/roomtypeInfo/queryList',
  'ROOM.TYPE.GET_LIST_BY_SHOPID': '/api/web/roomtypeInfo/queryByStoreId',
  'ROOM.TYPE.GET_DETAIL': '/api/web/roomtypeInfo/queryDetailById',
  'ROOM.TYPE.POST_SAVE': '/api/web/roomtypeInfo/saveOrUpdate',
  'ROOM.TYPE.DELETE': '/api/web/roomtypeInfo/deleteByIds',
  'ROOM.TYPE.SORT': '/api/web/roomtypeInfo/updateIndex',
  'ROOM.TYPE.GET_ROOM_PRICE': '/api/web/roomtypeInfo/getRoomRate',
}

const room_status_management = {
  'ROOM.STATUS.POST_QUERY': '/api/web/roomInfo/queryRoomStatus',
}

// 系统管理相关接口
const system_management = {
  // 系统参数
  'SYSTEM.PARAM.GET_LIST': '/api/web/systemParam/findPage',
  'SYSTEM.PARAM.GET_LIST_WITHOUT_AUTH': '/api/web/systemParam/findList',
  'SYSTEM.PARAM.POST_DELETE': '/api/web/systemParam/deleteByIds',
  'SYSTEM.PARAM.POST_SAVE_OR_UPDATE': '/api/web/systemParam/saveOrUpdate',

  // 字典管理
  'SYSTEM.DICT.GET_LIST': '/api/web/dictInfo/queryList',
  'SYSTEM.DICT.POST_DELETE': '/api/web/dictInfo/deleteByIds',
  'SYSTEM.DICT.GET_TYPE_LIST': '/api/web/dictInfo/queryTypeList',
  'SYSTEM.DICT.POST_ADD_OR_UPDATE': '/api/web/dictInfo/saveOrUpdate',

  // 配置项
  'SYSTEM.CONFIG.GET_LIST': '/api/web/auditConfig/queryList',
  'SYSTEM.CONFIG.POST_SAVE_OR_UPDATE': '/api/web/auditConfig/saveOrUpdate',
  'SYSTEM.CONFIG.POST_DELETE_BY_IDS': '/api/web/auditConfig/deleteByIds',

  // 数据推送
  'PUSH.CONFIG.GET_LIST': '/api/web/dataPushConfig/findPage',
  'PUSH.CONFIG.POST_SAVE': '/api/web/dataPushConfig/saveOrUpdate',
  'PUSH.CONFIG.DELETE': '/api/web/dataPushConfig/deleteByIds',
  'PUSH.CONFIG.CUSTOM': '/api/web/dataPush/customizeDataPush',
  'PUSH.SYSTEM_DATAPUSH_LOG': '/api/web/dataPushLog/findPage',

  // 操作日志
  'OPERATE.LOG.GET_LIST': '/api/web/operateLog/findPage'
}

const admin = {
  'ADMIN.BULLETIN_BOARD': '/api/web/home-page/admin/bulletinBoard', // 管理员-统计看板
  'ADMIN.CHECK_IN_STATISTIC': '/api/web/home-page/admin/checkInStatistic', // 管理员-入住统计
  'ADMIN.CHECK_IN_TREND_BY_DAY': '/api/web/home-page/admin/checkInTrendByDay', // 管理员-入住趋势(天)
  'ADMIN.CHECK_IN_TREND_BY_WEEK': '/api/web/home-page/admin/checkInTrendByWeek', // 管理员-入住趋势(周)
  'ADMIN.CUSTOMER_PORTRAIT_STATISTIC': '/api/web/home-page/admin/customerPortraitStatistic', // 管理员-客户画像
  'ADMIN.CUSTOMER_STATISTIC': '/api/web/home-page/admin/customerStatistic', // 管理员-客源地城市及占比
  'ADMIN.DEVICE_STATISTIC': '/api/web/home-page/admin/deviceStatistic', // 管理员-设备信息统计
  'ADMIN.ROOM_STATISTIC': '/api/web/home-page/admin/roomStatistic', // 管理员-房源统计
}

const areas = {
  'AREAS.GET_ALL_PROVINCES': '/api/web/areaInfo/getAllProvinces', // 查询所有省份数据
  'AREAS.GET_BY_PARENT_CODE': '/api/web/areaInfo/getByParentCode', // 根据父级code查询所有关联信息
  'COMBOBOX.FIND_AREA_LIST_BY_PARENT_CODE': '/api/web/areaInfo/getByParentCode', // 根据父级code查询所有关联信息
}

const service_fee = {
  // 服务费
  "查询配置": "/api/web/service-fee-config/getUserServiceFeeConfig",
  "保存配置": "/api/web/service-fee-config/saveOrUpdate",
  "统计": "/api/web/service-fee-account/getAccountStatistic",
  "充值记录": "/api/mini/manager/recharge/findPage",
  "消费记录": "/api/web/service-fee-record/findPage",
}

export default {
  ...saas_room_order_paths,
  ...manager_management,
  ...user_management,
  ...device_management,
  ...resource_management,
  ...role_management,
  ...shop_management,
  ...room_type_management,
  ...room_status_management,
  ...system_management,
  ...OTA,
  ...tenant,
  ...clean,
  ...alarm,
  ...admin,
  ...areas,
  ...visitor,
  ...service_fee,
};
